<template>
	<div class="business-receive-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.business_receive_page_v2.sec_01.title.one') }}<br />
					<strong>{{
						$t('new_ui.business_receive_page_v2.sec_01.title.two')
					}}</strong>
					{{ $t('new_ui.business_receive_page_v2.sec_01.title.three') }}
				</h2>

				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.business_receive_page_v2.sec_01.btn.one') }}
					</a>
					<a href="/service/cs/cs" class="btn-type-02">
						{{ $t('new_ui.business_receive_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-14">
			<div class="container-box">
				<a href="/service/cs/cs" class="btn-type-03">
					{{ $t('new_ui.business_receive_page_v2.sec_14.btn') }}
					<img :src="img.iconArrowRightCircle" alt="" />
				</a>
			</div>
		</section>
		<section class="sec-03">
			<div class="container-box">
				<div class="title-box">
					<h3>
						{{ $t('new_ui.business_receive_page_v2.sec_03.title.one') }}
					</h3>
					<p>{{ $t('new_ui.business_receive_page_v2.sec_03.desc.one') }}</p>
				</div>
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.business_receive_page_v2.sec_03.one.title.one')
							}}<br />
							{{ $t('new_ui.business_receive_page_v2.sec_03.one.title.two') }}
						</h3>
						<p>
							{{ $t('new_ui.business_receive_page_v2.sec_03.one.desc.one')
							}}<br />{{
								$t('new_ui.business_receive_page_v2.sec_03.one.desc.two')
							}}
						</p>
					</div>
					<div class="img-box">
						<img :src="img.imgBusinessReceiveSec0301" alt="" />
					</div>
				</div>
				<div class="txt-img-box">
					<div class="img-box">
						<img :src="img.imgBusinessReceiveSec0302" alt="" />
					</div>
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.business_receive_page_v2.sec_03.two.title.one') }}
						</h3>
						<p>
							{{ $t('new_ui.business_receive_page_v2.sec_03.two.desc.one') }}
							<br />
							{{ $t('new_ui.business_receive_page_v2.sec_03.two.desc.two') }}
						</p>
					</div>
				</div>
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{ $t('new_ui.business_receive_page_v2.sec_03.three.title.one') }}
							<br />
							{{ $t('new_ui.business_receive_page_v2.sec_03.three.title.two') }}
						</h3>
						<p>
							{{ $t('new_ui.business_receive_page_v2.sec_03.three.desc.one') }}
							<br />
							{{ $t('new_ui.business_receive_page_v2.sec_03.three.desc.two') }}
							<br />
							{{
								$t('new_ui.business_receive_page_v2.sec_03.three.desc.three')
							}}
						</p>
					</div>
					<div class="img-box">
						<img :src="img.imgBusinessReceiveSec0303" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section class="sec-15">
			<div class="container-box">
				<h3 class="title">
					{{ $t('new_ui.business_receive_page_v2.sec_15.title.one') }}
				</h3>

				<div class="card-box">
					<div class="card-content">
						<div class="top">
							<div class="txt">
								<h5>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.title.one',
										)
									}}
								</h5>
								<p>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.description.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.description.two',
										)
									}}
									<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.description.three',
										)
									}}
								</p>
							</div>
							<img :src="img.iconBusinessReceive01" alt="" />
						</div>
						<div class="bottom">
							<a @click="showComingSoon" class="btn-type-04">
								<template v-if="!isMobile">
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.btn_01.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.btn_01.two',
										)
									}}
								</template>
								<template v-else>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.btn_01.one',
										)
									}}
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.btn_01.two',
										)
									}}
								</template>
								<img :src="img.iconArrowRightCircle" alt="" />
							</a>
							<a @click="showComingSoon" class="btn-type-04">
								<template v-if="!isMobile">
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.btn_02.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.btn_02.two',
										)
									}}
								</template>
								<template v-else>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.btn_02.one',
										)
									}}
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.one.btn_02.two',
										)
									}}
								</template>
								<img :src="img.iconArrowRightCircle" alt="" />
							</a>
						</div>
					</div>
					<div class="card-content">
						<div class="top">
							<div class="txt">
								<h5>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.two.title.one',
										)
									}}
								</h5>
								<p>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.two.description.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.two.description.two',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.two.description.three',
										)
									}}
								</p>
							</div>
							<img :src="img.iconBusinessReceive02" alt="" />
						</div>
						<div class="bottom">
							<a @click="showComingSoon" class="btn-type-04">
								<template v-if="!isMobile">
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.two.btn.one',
										)
									}}<br />{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.two.btn.two',
										)
									}}
								</template>
								<template v-else>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.two.btn.one',
										)
									}}
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.two.btn.two',
										)
									}}
								</template>
								<img :src="img.iconArrowRightCircle" alt="" />
							</a>
						</div>
					</div>
					<div class="card-content">
						<div class="top">
							<div class="txt">
								<h5>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.three.title.one',
										)
									}}
								</h5>
								<p>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.three.description.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.three.description.two',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.three.description.three',
										)
									}}
								</p>
							</div>
							<img :src="img.iconBusinessReceive03" alt="" />
						</div>
						<div class="bottom">
							<a @click="showComingSoon" class="btn-type-04">
								<template v-if="!isMobile">
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.three.btn.one',
										)
									}}<br />{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.three.btn.two',
										)
									}}
								</template>
								<template v-else>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.three.btn.one',
										)
									}}
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.three.btn.two',
										)
									}}
								</template>
								<img :src="img.iconArrowRightCircle" alt="" />
							</a>
						</div>
					</div>
					<div class="card-content">
						<div class="top">
							<div class="txt">
								<h5>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.four.title.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.four.title.two',
										)
									}}
								</h5>
								<p>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.four.description.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.four.description.two',
										)
									}}
									<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.four.description.three',
										)
									}}
								</p>
							</div>
							<img :src="img.iconBusinessReceive04" alt="" />
						</div>
						<div class="bottom"></div>
					</div>
					<div class="card-content">
						<div class="top">
							<div class="txt">
								<h5>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.five.title.one',
										)
									}}
								</h5>
								<p>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.five.description.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.five.description.two',
										)
									}}
								</p>
							</div>
							<img :src="img.iconBusinessReceive05" alt="" />
						</div>
						<div class="bottom"></div>
					</div>
					<div class="card-content">
						<div class="top">
							<div class="txt">
								<h5>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.six.title.one',
										)
									}}
								</h5>
								<p>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.six.description.one',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.six.description.two',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.six.description.three',
										)
									}}<br />
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.six.description.four',
										)
									}}
								</p>
							</div>
							<img :src="img.iconBusinessReceive06" alt="" />
						</div>
						<div class="bottom">
							<a @click="showComingSoon" class="btn-type-04">
								<template v-if="!isMobile">
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.six.btn.one',
										)
									}}<br />{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.six.btn.two',
										)
									}}
								</template>
								<template v-else>
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.six.btn.one',
										)
									}}
									{{
										$t(
											'new_ui.business_receive_page_v2.sec_15.cards.six.btn.two',
										)
									}}
								</template>
								<img :src="img.iconArrowRightCircle" alt="" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import iconBusinessReceive01 from '@/assets/images/v2/icon/icon-business-receive-01.svg';
import iconBusinessReceive02 from '@/assets/images/v2/icon/icon-business-receive-02.svg';
import iconBusinessReceive03 from '@/assets/images/v2/icon/icon-business-receive-03.svg';
import iconBusinessReceive04 from '@/assets/images/v2/icon/icon-business-receive-04.svg';
import iconBusinessReceive05 from '@/assets/images/v2/icon/icon-business-receive-05.svg';
import iconBusinessReceive06 from '@/assets/images/v2/icon/icon-business-receive-06.svg';
import iconArrowRightCircle from '@/assets/images/v2/icon/icon-arrow-right-circle.svg';
import imgBusinessReceiveSec0301 from '@/assets/images/v2/img-business-receive-sec-03-01.png';
import imgBusinessReceiveSec0302 from '@/assets/images/v2/img-business-receive-sec-03-02.png';
import imgBusinessReceiveSec0303 from '@/assets/images/v2/img-business-receive-sec-03-03.png';

export default {
	data() {
		return {
			img: {
				iconBusinessReceive01,
				iconBusinessReceive02,
				iconBusinessReceive03,
				iconBusinessReceive04,
				iconBusinessReceive05,
				iconBusinessReceive06,
				iconArrowRightCircle,
				imgBusinessReceiveSec0301,
				imgBusinessReceiveSec0302,
				imgBusinessReceiveSec0303,
			},
			isMobile: false,
		};
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		showComingSoon() {
			alert(this.$t('new_ui.business_receive_page_v2.common.coming_soon'));
		},
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
	},
};
</script>
